import {
  Aldreomsorg,
  Ambulans,
  Atervinning,
  Bibliotek,
  Bostader,
  Brandkar,
  Energi,
  Fangelse,
  Fardtjanst,
  Folktandvard,
  Forskola,
  Forsvaret,
  Fritid,
  Invandring,
  Jordbruk,
  Kontaktperson,
  Kollektivtrafik,
  Kultur,
  Miljo,
  Museum,
  Parker,
  Parkering,
  Pension,
  Polis,
  Sjukhus,
  Skola,
  Sopor,
  Vardcentral,
  Vatten,
} from "../svg/";

export const questions = [
  {
    id: 0,
    name: "Museum",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/museum.png",
    border: <Museum />,
    question:
      "Du tycker dinosaurier är spännande och vill besöka Naturhistoriska museet i Stockholm. Vem bestämmer om Naturhistoriska museet och andra museer som är för hela landet?",
    answers: {
      kommun: {
        text: "Det är inte kommunen som ansvarar för museer som är för hela landet. Staten ansvarar för statens museer.",
        correct: false,
      },
      region: {
        text: "Det är inte regionen som ansvarar för museer som är för hela landet. Staten ansvarar för statens museer.",
        correct: false,
      },
      staten: {
        text: "Staten ansvarar för de museer som är för hela landet. De kallas för statens museer.",
        correct: true,
      },
    },
  },
  {
    id: 1,
    name: "Fängelse",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/f%C3%A4ngelse.png",
    border: <Fangelse />,
    question:
      "En person som bryter mot lagen får ibland fängelse som straff. Vem ansvarar för fängelserna?",
    answers: {
      kommun: {
        text: "Det är inte kommunen som ansvarar för fängelserna i Sverige. Staten ansvarar för fängelserna.",
        correct: false,
      },
      region: {
        text: "Det är inte regionen som ansvarar för fängelserna i Sverige. Staten ansvarar för fängelserna.",
        correct: false,
      },
      staten: {
        text: "Staten ansvarar för fängelserna i Sverige.",
        correct: true,
      },
    },
  },
  {
    id: 2,
    name: "Kultur",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/kultur.png",
    border: <Kultur />,
    question:
      "Du kanske kan se, höra och uppleva olika sorters kultur där du bor. Kultur kan vara konserter, teater och filmer på bio till exempel. Men vem ansvarar för kulturen där du bor?",
    answers: {
      kommun: {
        text: "Kommunen ansvarar för kultur där du bor tillsammans med regionen och staten. Alla har ansvar för kulturen i vårt land.",
        correct: true,
      },
      region: {
        text: "Regionen ansvarar för kultur där du bor tillsammans med kommunen och staten. Alla har ansvar för kulturen i vårt land.",
        correct: true,
      },
      staten: {
        text: "Staten ansvarar för kultur där du bor tillsammans med kommunen och regionen. Alla har ansvar för kulturen i vårt land.",
        correct: true,
      },
    },
  },
  {
    id: 3,
    name: "Miljö",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/milj%C3%B6.png",
    border: <Miljo />,
    question:
      "Många fabriker släpper ut rök som gör luften smutsig och dålig för vår miljö. Vem bestämmer vad vi måste göra för att inte förstöra miljön i Sverige?",
    answers: {
      kommun: {
        text: "Det är inte kommunen som bestämmer vad vi måste göra i Sverige för att inte förstöra vår miljö. Staten bestämmer om miljön.",
        correct: false,
      },
      region: {
        text: "Det är inte regionen som bestämmer vad vi måste göra i Sverige för att inte förstöra vår miljö. Staten bestämmer om miljön.",
        correct: false,
      },
      staten: {
        text: "Staten bestämmer vad vi måste göra i Sverige för att inte förstöra vår miljö.",
        correct: true,
      },
    },
  },
  {
    id: 4,
    name: "Jordbruk",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/jordbruk.png",
    border: <Jordbruk />,
    question:
      "Jordbruken i Sverige odlar olika växter som är viktiga för vår mat. Vem bestämmer regler för vilka ämnen jordbruken får använda för att växterna ska växa bra?",
    answers: {
      kommun: {
        text: "Det är inte kommunen som bestämmer reglerna för jordbruken. Staten bestämmer reglerna.",
        correct: false,
      },
      region: {
        text: "Det är inte regionen som bestämmer reglerna för jordbruken. Staten bestämmer reglerna.",
        correct: false,
      },
      staten: {
        text: "Staten bestämmer reglerna för vilka ämnen bönderna får använda i jordbruken. ",
        correct: true,
      },
    },
  },
  {
    id: 5,
    name: "Försvaret",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/f%C3%B6rsvaret.png",
    border: <Forsvaret />,
    question:
      "Sverige har ett försvar med militärer, vapen och flygplan till exempel. De ska försvara landet i krig. Vem bestämmer om försvaret?",
    answers: {
      kommun: {
        text: "Det är inte kommunen som bestämmer om försvaret. Staten bestämmer om försvaret.",
        correct: false,
      },
      region: {
        text: "Det är inte regionen som bestämmer om försvaret. Staten bestämmer om försvaret.",
        correct: false,
      },
      staten: {
        text: "Staten bestämmer om försvaret. ",
        correct: true,
      },
    },
  },
  {
    id: 6,
    name: "Energi",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/energi.png",
    border: <Energi />,
    question:
      "Du använder elektricitet varje dag, till lampan, spisen och tv:n till exempel. Vem bestämmer vilken typ av energi vi ska ha, alltså på vilket sätt vi ska skapa elektricitet i Sverige?",
    answers: {
      kommun: {
        text: "Det är inte kommunen som bestämmer energin. Staten bestämmer om energin.",
        correct: false,
      },
      region: {
        text: "Det är inte regionen som bestämmer energin. Staten bestämmer om energin.",
        correct: false,
      },
      staten: {
        text: "Staten bestämmer om energin i Sverige.",
        correct: true,
      },
    },
  },
  {
    id: 7,
    name: "Badhus",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/fritid.png",
    border: <Fritid />,
    question:
      "Du tycker om att simma och är ofta i simhallen. Vem bestämmer om simhallen där du bor?",
    answers: {
      kommun: {
        text: "Kommunen bestämmer om simhallen.",
        correct: true,
      },
      region: {
        text: "Det är inte regionen som bestämmer om simhallen. Kommunen bestämmer om simhallen.",
        correct: false,
      },
      staten: {
        text: "Det är inte staten som bestämmer om simhallen. Kommunen bestämmer om simhallen. ",
        correct: false,
      },
    },
  },
  {
    id: 8,
    name: "Brandkåren",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/brandk%C3%A5r.png",
    border: <Brandkar />,
    question:
      "Brandkåren kommer och släcker branden om det brinner i ett hus. Men vem ansvarar för brandkåren där du bor?",
    answers: {
      kommun: {
        text: "Kommunen ansvarar för brandkåren där du bor.",
        correct: true,
      },
      region: {
        text: "Det är inte regionen som ansvarar för brandkåren där du bor. Kommunen ansvarar för brandkåren.",
        correct: false,
      },
      staten: {
        text: "Det är inte staten som ansvarar för brandkåren där du bor. Kommunen ansvarar för brandkåren.",
        correct: false,
      },
    },
  },
  {
    id: 9,
    name: "Återvinning",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/%C3%A5tervinning.png",
    border: <Atervinning />,
    question:
      "Det är viktigt för miljön att du sorterar dina sopor och lägger dem på rätt plats vid stationen för återvinning. Vem bestämmer om sorteringen av sopor där du bor?",
    answers: {
      kommun: {
        text: "Kommunen bestämmer om sorteringen av sopor där du bor.",
        correct: true,
      },
      region: {
        text: "Det är inte regionen som bestämmer om sorteringen av sopor där du bor. Kommunen bestämmer om sorteringen av sopor.",
        correct: false,
      },
      staten: {
        text: "Det är inte staten som bestämmer om sorteringen av sopor där du bor. Kommunen bestämmer om sorteringen av sopor.",
        correct: false,
      },
    },
  },
  {
    id: 10,
    name: "Nya bostäder där du bor",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/bost%C3%A4der.png",
    border: <Bostader />,
    question:
      "Du vill ha en egen lägenhet. Men det finns inga lediga lägenheter där du bor. Vem bestämmer om platsen för nya bostäder?",
    answers: {
      kommun: {
        text: "Kommunen bestämmer platsen för nya bostäder där du bor.",
        correct: true,
      },
      region: {
        text: "Det är inte regionen som bestämmer om platsen för nya bostäder där du bor. Kommunen bestämmer om platsen för bostäder.",
        correct: false,
      },
      staten: {
        text: "Det är inte staten som bestämmer om platsen för nya bostäder där du bor. Kommunen bestämmer om bostäder.",
        correct: false,
      },
    },
  },
  {
    id: 11,
    name: "Ambulans",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/ambulans.png",
    border: <Ambulans />,
    question:
      "Många som blir sjuka måste åka ambulans till sjukhuset. Vem ansvarar för ambulansen?",
    answers: {
      kommun: {
        text: "Det är inte kommunen som ansvarar för ambulansen där du bor. Regionen ansvarar för ambulansen.",
        correct: false,
      },
      region: {
        text: "Regionen ansvarar för ambulansen där du bor.",
        correct: true,
      },
      staten: {
        text: "Det är inte staten som ansvarar för ambulansen där du bor. Regionen ansvarar för ambulansen.",
        correct: false,
      },
    },
  },
  {
    id: 12,
    name: "Sjukhus",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/v%C3%A5rd.png",
    border: <Sjukhus />,
    question:
      "Du har kanske varit på sjukhus någon gång. Men vem ansvarar för sjukhuset där du bor?",
    answers: {
      kommun: {
        text: "Det är inte kommunen som ansvarar för sjukhuset där du bor. Regionen ansvarar för sjukhuset.",
        correct: false,
      },
      region: {
        text: "Regionen ansvarar för sjukhuset där du bor.",
        correct: true,
      },
      staten: {
        text: "Det är inte staten som ansvarar för sjukhuset där du bor. Regionen ansvarar för sjukhuset.",
        correct: false,
      },
    },
  },
  {
    id: 13,
    name: "Vårdcentral",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/v%C3%A5rd.png",
    border: <Vardcentral />,
    question:
      "Du har ont i halsen och får träffa en läkare på din vårdcentral. Vem bestämmer om vårdcentralen där du bor?",
    answers: {
      kommun: {
        text: "Det är inte kommunen som ansvarar för vårdcentralen där du bor. Regionen ansvarar för vårdcentralen.",
        correct: false,
      },
      region: {
        text: "Regionen ansvarar för vårdcentralen där du bor.",
        correct: true,
      },
      staten: {
        text: "Det är inte staten som ansvarar för vårdcentralen där du bor. Regionen ansvarar för vårdcentralen.",
        correct: false,
      },
    },
  },
  {
    id: 14,
    name: "Folktandvården",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/v%C3%A5rd.png",
    border: <Folktandvard />,
    question:
      "Du har ont i en tand och du ringer till folktandvården för att boka en tid. Vem bestämmer om folktandvården där du bor?",
    answers: {
      kommun: {
        text: "Det är inte kommunen som ansvarar för folktandvården där du bor. Regionen ansvarar för folktandvården.",
        correct: false,
      },
      region: {
        text: "Regionen ansvarar för folktandvården där du bor.",
        correct: true,
      },
      staten: {
        text: "Det är inte staten som ansvarar för folktandvården där du bor. Regionen ansvarar för folktandvården.",
        correct: false,
      },
    },
  },
  {
    id: 15,
    name: "Sopor",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/sopor.png",
    border: <Sopor />,
    question:
      "Sopbilen kommer varje vecka och hämtar dina sopor. Men vem bestämmer om sopbilarna?",
    answers: {
      kommun: {
        text: "Kommunen bestämmer om sopbilarna där du bor.",
        correct: true,
      },
      region: {
        text: "Det är inte regionen som bestämmer om sopbilarna där du bor. Kommunen bestämmer om sopbilarna.",
        correct: false,
      },
      staten: {
        text: "Det är inte staten som bestämmer om sopbilarna där du bor. Kommunen bestämmer om sopbilarna.",
        correct: false,
      },
    },
  },
  {
    id: 16,
    name: "Polisen",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/polis.png",
    border: <Polis />,
    question:
      "Polisen arbetar med att göra Sverige tryggt och säkert för oss att leva i. De ska stoppa personer som inte följer lagen. Vem ansvarar för polisen?",
    answers: {
      kommun: {
        text: "Det är inte kommunen som ansvarar för polisen i Sverige. Staten ansvarar för polisen.",
        correct: false,
      },
      region: {
        text: "Det är inte regionen som ansvarar för polisen i Sverige. Staten ansvarar för polisen.",
        correct: false,
      },
      staten: {
        text: "Staten ansvarar för polisen i Sverige.",
        correct: true,
      },
    },
  },
  {
    id: 17,
    name: "Kollektivtrafik",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/kollektivtrafik.png",
    border: <Kollektivtrafik />,
    question:
      "Du måste resa med buss till ditt arbete. Vem bestämmer om bussarna där du bor?",
    answers: {
      kommun: {
        text: "Det är inte kommunen som bestämmer om bussarna. Regionen bestämmer om kollektivtrafiken.",
        correct: false,
      },
      region: {
        text: "Regionen bestämmer om bussarna och kollektivtrafiken där du bor. Kollektivtrafik är bussar, tunnelbana och spårvagnar till exempel.",
        correct: true,
      },
      staten: {
        text: "Det är inte staten som bestämmer om bussarna. Regionen bestämmer om kollektivtrafiken.",
        correct: false,
      },
    },
  },
  {
    id: 18,
    name: "Bibliotek",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/bibliotek.png",
    border: <Bibliotek />,
    question:
      "Du tycker om att låna böcker på biblioteket. Vem bestämmer om biblioteket?",
    answers: {
      kommun: {
        text: "Kommunen bestämmer om biblioteket där du bor.",
        correct: true,
      },
      region: {
        text: "Det är inte regionen som bestämmer om biblioteket där du bor. Kommunen bestämmer om biblioteket.",
        correct: false,
      },
      staten: {
        text: "Det är inte staten som bestämmer om biblioteket där du bor. Kommunen bestämmer om biblioteket.",
        correct: false,
      },
    },
  },
  {
    id: 19,
    name: "Parkering",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/parkering.png",
    border: <Parkering />,
    question:
      "På många platser i Sverige kan det vara svårt att hitta en plats att parkera bilen. Vem bestämmer var du får parkera?",
    answers: {
      kommun: {
        text: "Kommunen bestämmer var du får parkera bilen. ",
        correct: true,
      },
      region: {
        text: "Det är inte regionen som bestämmer var du får parkera bilen. Kommunen bestämmer var du får parkera.",
        correct: false,
      },
      staten: {
        text: "Det är inte staten som bestämmer var du får parkera bilen. Kommunen bestämmer var du får parkera.",
        correct: false,
      },
    },
  },
  {
    id: 20,
    name: "Färdtjänst",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/f%C3%A4rdtj%C3%A4nst.png",
    border: <Fardtjanst />,
    question:
      "Du reser med färdtjänst till dina aktiviteter. Vem bestämmer om du får färdtjänst?",
    answers: {
      kommun: {
        text: "Kommunen bestämmer om du får eller inte får färdtjänst. Men ibland har regionen ansvar för färdtjänstens taxi och bussar.",
        correct: true,
      },
      region: {
        text: "Det är inte regionen som bestämmer om du får färdtjänst. Kommunen bestämmer om du får eller inte får färdtjänst.",
        correct: false,
      },
      staten: {
        text: "Det är inte staten som bestämmer om du får färdtjänst. Kommunen bestämmer om du får eller inte får färdtjänst.",
        correct: false,
      },
    },
  },
  {
    id: 21,
    name: "Skola",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/skola.png",
    border: <Skola />,
    question:
      "Det är skolplikt i Sverige. Det betyder att alla barn ska gå i skolan. Vem ansvarar för skolorna där du bor?",
    answers: {
      kommun: {
        text: "Kommunen ansvarar för skolorna där du bor.",
        correct: true,
      },
      region: {
        text: "Det är inte regionen som bestämmer om skolorna där du bor. Kommunen ansvarar för skolorna.",
        correct: false,
      },
      staten: {
        text: "Det är inte staten som bestämmer om skolorna i din stad. Kommunen ansvarar för skolorna.",
        correct: false,
      },
    },
  },
  {
    id: 22,
    name: "Parker",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/parker.png",
    border: <Parker />,
    question:
      "Städerna i Sverige har många fina parker. Vem bestämmer om parkerna?",
    answers: {
      kommun: {
        text: "Kommunerna bestämmer om parkerna om parkerna som finns i städerna.",
        correct: true,
      },
      region: {
        text: "Det är inte regionen som bestämmer om parkerna. Kommunen bestämmer om parkerna.",
        correct: false,
      },
      staten: {
        text: "Det är inte staten som bestämmer om parkerna. Kommunen bestämmer om parkerna.",
        correct: false,
      },
    },
  },
  {
    id: 23,
    name: "Förskola",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/f%C3%B6rskola.png",
    border: <Forskola />,
    question:
      "Många barn går i förskolan innan de börjar i vanliga skolan. Vem bestämmer om förskolan där du bor?",
    answers: {
      kommun: {
        text: "Kommunen bestämmer om förskolorna där du bor.",
        correct: true,
      },
      region: {
        text: "Det är inte regionen som bestämmer om förskolorna där du bor. Kommunen bestämmer om förskolorna.",
        correct: false,
      },
      staten: {
        text: "Det är inte staten som bestämmer om förskolorna där du bor. Kommunen bestämmer om förskolorna.",
        correct: false,
      },
    },
  },
  {
    id: 24,
    name: "Flyktingar",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/invandring.png",
    border: <Invandring />,
    question:
      "Det har kommit många flyktingar från andra länder till Sverige. Vem bestämmer om flyktingar får stanna i vårt land?",
    answers: {
      kommun: {
        text: "Det är inte kommunen som bestämmer om flyktingar får stanna. Staten bestämmer om flyktingarna.",
        correct: false,
      },
      region: {
        text: "Det är inte regionen som bestämmer om flyktingar får stanna. Staten bestämmer om flyktingarna.",
        correct: false,
      },
      staten: {
        text: "Staten bestämmer vilka flyktingar som får stanna i Sverige. ",
        correct: true,
      },
    },
  },
  {
    id: 25,
    name: "Äldreomsorg",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/%C3%A4ldreomsorg.png",
    border: <Aldreomsorg />,
    question:
      "Många människor behöver extra stöd och service när de blir gamla. De behöver äldreomsorg. Vem bestämmer om äldreomsorgen där du bor?",
    answers: {
      kommun: {
        text: "Kommunen bestämmer om äldreomsorgen där du bor.",
        correct: true,
      },
      region: {
        text: "Det är inte regionen som bestämmer om äldreomsorgen där du bor. Kommunen bestämmer om äldreomsorgen.",
        correct: false,
      },
      staten: {
        text: "Det är inte staten som bestämmer om äldreomsorgen där du bor. Kommunen bestämmer om äldreomsorgen.",
        correct: false,
      },
    },
  },
  {
    id: 26,
    name: "Pensioner",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/pension.png",
    border: <Pension />,
    question:
      "När du blir gammal får du pension. Vem bestämmer om pensionerna?",
    answers: {
      kommun: {
        text: "Det är inte kommunen som bestämmer om pensionerna. Staten bestämmer om pensionerna.",
        correct: false,
      },
      region: {
        text: "Det är inte regionen som bestämmer om pensionerna. Staten bestämmer om pensionerna.",
        correct: false,
      },
      staten: {
        text: "Staten bestämmer om pensionerna i Sverige.",
        correct: true,
      },
    },
  },
  {
    id: 27,
    name: "Vatten",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/vatten.png",
    border: <Vatten />,
    question:
      "Du använder mycket vatten varje dag, när du lagar mat, tvättar dig och spolar på toaletten till exempel. Vem ansvarar för att du har rent vatten?",
    answers: {
      kommun: {
        text: "Kommunen ansvarar för att vattnet är rent.",
        correct: true,
      },
      region: {
        text: "Det är inte regionen som ansvarar för vattnet. Kommunen ansvarar för vattnet.",
        correct: false,
      },
      staten: {
        text: "Det är inte staten som ansvarar för vattnet. Kommunen ansvarar för vattnet.",
        correct: false,
      },
    },
  },
  {
    id: 28,
    name: "Kontaktperson",
    img: "https://who-decides-test.s3.eu-north-1.amazonaws.com/kontaktperson.png",
    border: <Kontaktperson />,
    question:
      "Du har kanske en kontaktperson som hjälper dig med olika saker i vardagen. Vem bestämmer om du får en kontaktperson?",
    answers: {
      kommun: {
        text: "Kommunen bestämmer om du får en kontaktperson.",
        correct: true,
      },
      region: {
        text: "Det är inte regionen som bestämmer om kontaktpersoner. Kommunen bestämmer om kontaktpersoner.",
        correct: false,
      },
      staten: {
        text: "Det är inte staten som bestämmer kontaktpersoner. Kommunen bestämmer om kontaktpersoner.",
        correct: false,
      },
    },
  },
];

// const shuffle = (array) => {
//   var currentIndex = array.length,
//     temporaryValue,
//     randomIndex;

//   while (currentIndex !== 0) {
//     randomIndex = Math.floor(Math.random() * currentIndex);
//     currentIndex -= 1;
//     temporaryValue = array[currentIndex];
//     array[currentIndex] = array[randomIndex];
//     array[randomIndex] = temporaryValue;
//   }

//   return array;
// };

// shuffle(questions);
